import React, { useState } from "react";
import { useI18n } from "../i18n/LanguageContext";
import { ChevronDown } from "lucide-react";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, langs } = useI18n();
  const [open, setOpen] = useState(false);
  const current = langs.find((l) => l.code === lang);

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 text-xs tracking-widest text-vm-text2 hover:text-vm-text transition-colors uppercase"
        aria-label="Change language" data-testid="language-switcher-button"
      >
        {current?.label}
        <ChevronDown strokeWidth={1.25} size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className={`absolute ${compact ? "bottom-full mb-2" : "top-full mt-3"} right-0 z-50 bg-vm-surface border border-vm-border min-w-[130px]`}>
            {langs.map((l) => (
              <button
                key={l.code}
                onClick={() => { setLang(l.code); setOpen(false); }}
                className={`block w-full text-left px-4 py-2.5 text-xs tracking-wide hover:bg-black/40 transition-colors ${l.code === lang ? "text-vm-accent" : "text-vm-text2"}`}
                data-testid={`lang-option-${l.code}`}
              >
                {l.name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
